import CloseIcon from '@mui/icons-material/Close'
import {
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Typography,
} from '@mui/material'
import { isValidPhoneNumber } from 'libphonenumber-js'
import { useEffect, useState } from 'react'
import PhoneInput from 'react-phone-input-2'
// import 'react-phone-input-2/lib/style.css'

export default function HoldSlotAndSendLinkOptions({
  holdSlotAndSendLinkToPay,
  setShowHoldSlotAndSendLinkOptions,
  relativeInformation,
  bookingLoading,
}) {
  const [sendLinkToPatient, setSendLinkToPatient] = useState(true)
  const [sendLinkToRelative, setSendLinkToRelative] = useState(false)
  const [customPhonesToSendLinkTo, setCustomPhonesToSendLinkTo] = useState([])
  const [sendLinkToCustomPhones, setSendLinkToCustomPhones] = useState(false)
  const [phoneValidationErrors, setPhoneValidationErrors] = useState({})

  const validatePhoneNumber = (phone) => {
    try {
      // Remove any non-digit characters except + for country code
      const cleanedPhone = phone.replace(/[^\d+]/g, '')
      // If the number doesn't start with +, add it
      const phoneWithPlus = cleanedPhone.startsWith('+') ? cleanedPhone : `+${cleanedPhone}`
      return isValidPhoneNumber(phoneWithPlus)
    } catch (error) {
      return false
    }
  }

  const handlePhoneChange = (e) => {
    const phones = e.target.value
    setCustomPhonesToSendLinkTo(phones)
    // Validate each phone number and store errors
    const errors = {}
    phones.forEach((phone, index) => {
      if (phone && !validatePhoneNumber(phone)) {
        errors[index] = 'Invalid phone number'
      }
    })
    setPhoneValidationErrors(errors)
  }

  const validatePhones = (phones) => {
    const errors = {}
    phones.forEach((phone, index) => {
      if (phone && !validatePhoneNumber(phone)) {
        errors[index] = 'Invalid phone number'
      }
    })
    setPhoneValidationErrors(errors)
  }

  let hasInvalidPhones = false
  if (sendLinkToCustomPhones) {
    hasInvalidPhones =
      Object.keys(phoneValidationErrors).length > 0 ||
      customPhonesToSendLinkTo?.some((phone) => !phone)
  }

  useEffect(() => {
    if (customPhonesToSendLinkTo.length === 0) {
      setSendLinkToCustomPhones(false)
    }
  }, [customPhonesToSendLinkTo])

  console.log({ customPhonesToSendLinkTo, relativeInformation })

  return (
    <>
      <DialogTitle>Hold Slot and Send Link to Pay</DialogTitle>
      <DialogContent>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  checked={sendLinkToPatient}
                  onChange={(e) => setSendLinkToPatient(e.target.checked)}
                />
              }
              label="Send link to patient"
            />
          </div>

          {relativeInformation && (
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={sendLinkToRelative}
                    onChange={(e) => setSendLinkToRelative(e.target.checked)}
                  />
                }
                label={`Send link to relative (${relativeInformation?.mobile} ${relativeInformation?.name})`}
              />
              {/* <div>
                <div className="fw-bolder m-0">
                  <span style={{ color: '#a2a2a2', fontSize: '12px' }}>
                    ({relativeInformation?.patientNumber})
                  </span>
                  {` ${relativeInformation?.name}'s ${relativeInformation?.dependentRelation}`}
                </div>
              </div> */}
            </div>
          )}
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  checked={sendLinkToCustomPhones}
                  onChange={(e) => {
                    if (!e.target.checked) {
                      setSendLinkToCustomPhones(false)
                    } else {
                      if (customPhonesToSendLinkTo.length === 0) {
                        setCustomPhonesToSendLinkTo([''])
                      }
                      setSendLinkToCustomPhones(true)
                    }
                  }}
                />
              }
              label="Send link to custom phone numbers"
            />
          </div>

          {sendLinkToCustomPhones && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {customPhonesToSendLinkTo.map((phone, index) => (
                <div className="w-100 d-flex flex-column" key={index}>
                  <div
                    key={index}
                    style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}
                  >
                    <PhoneInput
                      country="in"
                      value={phone}
                      disableDropdown
                      onChange={(value) => {
                        const newPhones = [...customPhonesToSendLinkTo]
                        newPhones[index] = value
                        setCustomPhonesToSendLinkTo(newPhones)
                        validatePhones(newPhones)
                      }}
                      inputProps={{
                        name: `phone-${index}`,
                      }}
                      enableSearch={true}
                      searchPlaceholder="Search country..."
                    />
                    <IconButton
                      onClick={() => {
                        const newPhones = customPhonesToSendLinkTo.filter((_, i) => i !== index)
                        setCustomPhonesToSendLinkTo(newPhones)
                        const newErrors = { ...phoneValidationErrors }
                        delete newErrors[index]
                        setPhoneValidationErrors(newErrors)
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </div>
                  {phoneValidationErrors[index] && (
                    <Typography color="error" variant="caption" style={{ marginTop: '4px' }}>
                      {phoneValidationErrors[index]}
                    </Typography>
                  )}
                </div>
              ))}

              <Button
                variant="outlined"
                size="small"
                // disabled={() => {
                // //   if (customPhonesToSendLinkTo.some((phone) => !phone)) {
                // //     return true
                // //   }
                //   return hasInvalidPhones
                // }}
                disabled={hasInvalidPhones}
                onClick={() => {
                  setCustomPhonesToSendLinkTo([...customPhonesToSendLinkTo, ''])
                }}
                style={{ alignSelf: 'flex-start' }}
              >
                Add Phone Number
              </Button>
            </div>
          )}
          {/* <AutomaticListAddingComponent
            id="customPhonesToSendLinkTo"
            label="Custom Phones to Send Link To"
            value={customPhonesToSendLinkTo}
            onChange={handlePhoneChange}
            extraInputProps={{
              placeholder: 'Enter phone number',
              country: 'in',
              enableSearch: true,
              searchPlaceholder: 'Search country...',
              inputProps: {
                name: 'phone',
                // required: true,
              },
            }}
            InputComponent={PhoneInput}
            getValueFromSinlgeInput={(e) => e}
            maxWidthOfItems="100px"
            inputItemPrefix="+"
            error={hasInvalidPhones}
            helperText={hasInvalidPhones ? 'One or more phone numbers are invalid' : ''}
          /> */}
        </div>
      </DialogContent>
      <DialogActions>
        <Button color="unFocused" onClick={() => setShowHoldSlotAndSendLinkOptions(false)}>
          Cancel
        </Button>
        <Button
          disabled={hasInvalidPhones}
          variant="contained"
          onClick={() =>
            holdSlotAndSendLinkToPay({
              sendLinkToPatient,
              sendLinkToRelative,
              customPhonesToSendLinkTo: sendLinkToCustomPhones
                ? customPhonesToSendLinkTo?.filter((phone) => phone && validatePhoneNumber(phone))
                : [],
            })
          }
        >
          {bookingLoading ? 'Booking...' : 'Hold Slot and Send Link to Pay'}
        </Button>
      </DialogActions>
    </>
  )
}
